module.exports = __webpack_public_path__ + "static/rpg-61d5bfa1da4be3f837527b2daea8ee31.png";